import { useState } from "react";
import axios from "@/lib/api";
import CarTable from "./CarTable";
import { exportCarsToExcel } from "@/utils/exportExcel";
// import { Plus } from "lucide-react";
// import { useNavigate } from "react-router-dom";

const CarsPage = () => {
  // const navigate = useNavigate();
  const [statusFilter, setStatusFilter] = useState("All");
  const [searchQuery, setSearchQuery] = useState("");

  const handleExport = async () => {
    try {
      const res = await axios.get("/cars");
      const exportData = res.data.map((car: any) => ({
        name: car.name,
        model: car.model,
        engine: car.engine,
        plate: car.plate,
        status: car.status,
        "BT Rate": car.regionRates?.bt ?? "N/A",
        "Eastern Rate": car.regionRates?.eastern ?? "N/A",
        "Central Rate": car.regionRates?.central ?? "N/A",
        "Northern Rate": car.regionRates?.northern ?? "N/A",
      }));
      exportCarsToExcel(exportData);
    } catch (err) {
      console.error("Failed to export", err);
    }
  };

  return (
    <div className="">
      {/* Optional Add Button */}
      {/* <div className="flex justify-end mb-6">
        <button
          onClick={() => navigate("/cars/add")}
          className="p-2 text-blue-900 bg-yellow-400 rounded hover:bg-yellow-300"
          title="Add New Car"
        >
          <Plus className="w-5 h-5" />
        </button>
      </div> */}

      {/* Filter & Export Section */}
      <div className="flex flex-col gap-4 mb-4 sm:flex-row sm:items-center sm:justify-between">
        {/* Left Side: Filters */}
        <div className="flex flex-wrap gap-2">
          <select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            className="px-6 py-2 text-sm text-gray-500 bg-white border border-gray-300 rounded appearance-none"
          >
            <option value="All" disabled hidden>
              Filter by status
            </option>
            <option value="All">All</option>
            <option value="Available">Available</option>
            <option value="Booked">Booked</option>
            <option value="Under Repair">Under Repair</option>
          </select>

          <input
            type="text"
            placeholder="Search by car name, model, or plate"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-64 px-3 py-2 text-sm border border-gray-300 rounded"
          />
        </div>

        {/* Right Side: Export Button */}
        <div className="flex justify-end">
          <button
            onClick={handleExport}
            className="px-2 py-1 text-sm font-semibold text-white bg-blue-800 rounded hover:bg-blue-900"
          >
            Export
          </button>
        </div>
      </div>

      {/* Car Table */}
      <CarTable filterStatus={statusFilter} search={searchQuery} />
    </div>
  );
};

export default CarsPage;
